import { NavLink, useLocation } from "react-router-dom";
import { Home, Calendar, Ticket, Settings, User } from "lucide-react";
import { cn } from "@/lib/utils";
import { useResponsiveLayout } from "@/hooks/useResponsiveLayout";

const navItems = [
  { icon: Home, label: "Home", path: "/dashboard" },
  { icon: Calendar, label: "Events", path: "/dashboard/events" },
  { icon: Ticket, label: "Tickets", path: "/dashboard/tickets" },
  { icon: Settings, label: "Settings", path: "/dashboard/settings" },
  { icon: User, label: "Profile", path: "/dashboard/profile" },
];

export const EnhancedMobileBottomNav = () => {
  const location = useLocation();
  const { isMobile } = useResponsiveLayout();
  
  // Only show on mobile and dashboard routes
  if (!isMobile || !location.pathname.startsWith('/dashboard')) {
    return null;
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 md:hidden">
      {/* iOS-style home indicator */}
      <div className="flex justify-center pb-1 bg-background/95 backdrop-blur-md">
        <div className="w-32 h-1 bg-foreground/20 rounded-full"></div>
      </div>
      
      <nav className="glass-card border-t border-border/50 px-2 py-1">
        <div className="flex items-center justify-around">
          {navItems.map((item) => {
            const Icon = item.icon;
            const isActive = location.pathname === item.path;
            
            return (
              <NavLink
                key={item.path}
                to={item.path}
                className={cn(
                  "flex flex-col items-center justify-center",
                  "min-h-[48px] min-w-[48px] px-2 py-1 rounded-lg",
                  "transition-all duration-200 ease-out",
                  "touch-manipulation select-none",
                  "active:scale-95",
                  isActive 
                    ? "text-primary bg-primary/10 scale-105" 
                    : "text-muted-foreground hover:text-foreground hover:bg-accent/50"
                )}
              >
                <Icon className={cn(
                  "h-5 w-5 transition-all duration-200",
                  isActive && "animate-bounce-gentle"
                )} />
                <span className={cn(
                  "text-xs font-medium mt-0.5 transition-all duration-200",
                  isActive ? "text-primary font-semibold" : "text-muted-foreground"
                )}>
                  {item.label}
                </span>
                
                {/* Active indicator */}
                {isActive && (
                  <div className="absolute -top-0.5 left-1/2 transform -translate-x-1/2 w-1 h-1 bg-primary rounded-full animate-pulse" />
                )}
              </NavLink>
            );
          })}
        </div>
      </nav>
      
      {/* Safe area padding for iOS */}
      <div className="h-safe-area-inset-bottom bg-background/95 backdrop-blur-md"></div>
    </div>
  );
};